<template>
    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-product-hunt text-primary mr-2"></i>
                    Gestión de Proyectos Associados
                </h4>
            </b-col>
        </b-row>

        <b-row class="pb-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Listado
                    <export-actions :rows="getAssociatedProjectFilteredData()"></export-actions>
                </b-row>
                <v-client-table
                    ref="AssociatedProjectTable"
                    class="dataTable"
                    md="12"
                    lg="12"
                    sm="12"
                    :columns="columns"
                    :data="associatedProjects"
                    :options="options"
                    :theme="theme" @filter="onFilter">

                    <template v-if="mixinCheckPermission('ASSOCIATED_PROJECT_EDIT')" slot="uuid" slot-scope="props">

                        <router-link :to="{ path: '/admin/associated-projects/edit/'+props.row.uuid }">
                            <i class="fa fa-pencil"></i>
                        </router-link>

                    </template>

                    <template slot="startDate" slot-scope="props">
                        <span v-if="props.row.startDate">{{props.row.startDate | dateFormat('DD/MM/YYYY')}}</span>
                    </template>

                    <template slot="endDate" slot-scope="props">
                        <span v-if="props.row.endDate">{{props.row.endDate | dateFormat('DD/MM/YYYY')}}</span>
                    </template>

                    <template slot="description" slot-scope="props">
                        <span v-if="!props.row.description || props.row.description.length <= 124">{{props.row.description}}</span>
                        <span
                            v-else
                            v-b-tooltip.hover.right
                            :title="props.row.description">{{props.row.description | truncate(124)}}</span>
                    </template>

                    <template slot="active" slot-scope="props">
                        <template v-if="props.row.active">Si</template>
                        <template v-else>No</template>
                    </template>

                </v-client-table>

            </b-card>
        </b-row>

    </div>
</template>

<script>

    import Vue from 'vue';
    import form from '@/helpers/form';
    import {ClientTable} from 'vue-tables-2';
    import ExportActions from '@/components/ExportActions';
    import {getAssociatedProjects} from '@/api/associated-project-api';

    Vue.use(ClientTable);

    export default {
        name: 'list-query-answer-types',
        components: {
            ExportActions
        },
        data: function () {
            return {
                topmenu: [
                    {
                        name: 'Inicio',
                        path: '/admin/dashboard',
                        brand: 'fa fa-home'
                    },
                    {
                        name: 'Nueva Proyecto Asociado',
                        path: '/admin/associated-projects/add',
                        brand: 'fa fa-product-hunt'
                    },
                ],
                columns: ['uuid', 'name', 'description', 'startDate', 'endDate', 'active'],
                options: {
                    headings: {
                        uuid: {
                            text: '',
                            id: 'fit'
                        },
                        name: 'Nombre',
                        description: 'Descripción',
                        startDate: 'Fecha inicio',
                        endDate: 'Fecha fin',
                        active: 'Activo',

                    },
                    columnsClasses: {uuid: "fit", description: "description-width"},
                    sortable: ['name', 'description', 'startDate', 'endDate', 'active'],
                    filterable: ['name', 'description'],
                    sortIcon: {
                        base: 'fa',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc',
                        is: 'fa-sort'
                    },
                    texts: null,
                    pagination: {
                        chunk: 10,
                        edge: true,
                        nav: 'scroll'
                    }
                },
                useVuex: false,
                theme: 'bootstrap4',
                template: 'default',
                associatedProjects: [],
            }
        },
        mounted() {
            this.options.texts = form.tableLabels();
            this.$eventHub.$emit('captureMenu', this.topmenu);
            this.getAssociatedProjects();
        },
        methods: {

            async getAssociatedProjects() {

                this.$_loadingMixin_showLoading();

                await getAssociatedProjects()
                    .then((associatedProjects) => {
                        this.associatedProjects = associatedProjects;
                      let searchValue = this.$store.getters.getTextFilter;
                      if (searchValue === null || searchValue === '') {
                        //console.log(this.headquarters)
                      }  else {
                        document.querySelector('.VueTables__search__input').value  = this.$store.getters.getTextFilter;
                        let filteredLists = []
                        this.associatedProjects.map(function (e) {
                          if (e.name.includes(searchValue) || e.description.includes(searchValue)) {
                            filteredLists.push(e)
                          }
                        });
                        this.associatedProjects = filteredLists;
                      }
                    });

                this.$_loadingMixin_hideLoading();
            },

            getAssociatedProjectFilteredData() {
                if (!!this.$refs.AssociatedProjectTable) {
                    return this.$refs.AssociatedProjectTable.allFilteredData.map(associatedProject => ({
                        'Nombre': associatedProject.name,
                        'Descripción': associatedProject.description,
                        'Fecha inicio': new Date(associatedProject.startDate).toLocaleDateString(),
                        'Fecha fin': new Date(associatedProject.endDate).toLocaleDateString(),
                        'Creada por': associatedProject.createdBy.name,
                        'Creación': new Date(associatedProject.createdAt).toLocaleDateString(),
                        'Actualizada por': associatedProject.updatedBy.name,
                        'Actualización': new Date(associatedProject.updatedAt).toLocaleDateString(),
                        'Activo': associatedProject.active ? "Si" : "No",
                    }));
                } else {
                    return [];
                }
            },
            onFilter () {
              let _self = this;
              if (document.querySelector('.VueTables__search__input').value === '') {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
                _self.getAssociatedProjects();
              } else {
                _self.$store.commit('SET_USER_TEXT_FILTER', document.querySelector('.VueTables__search__input').value)
              }
            }
        }
    }
</script>

<style>
    .description-width {
        width: 40%;
    }
</style>
